import React from 'react';

import { Button } from '@mui/material';

interface Props {
  approved: boolean;
  fullWidth?: boolean;
  hidden?: boolean;
  onApprove?: () => void;
  onUnapprove?: () => void;
}

export default function ApprovalActionButton({ approved, fullWidth, hidden, onApprove, onUnapprove }: Props) {
  if (approved) {
    return (
      <Button size="small" variant="outlined" color="error" fullWidth={fullWidth} onClick={onUnapprove}>
        Unapprove
      </Button>
    );
  }

  if (hidden) {
    return null;
  }

  return (
    // Black, not primary blue — deliberate design call, not yet promoted to the theme.
    <Button
      size="small"
      variant="contained"
      fullWidth={fullWidth}
      onClick={onApprove}
      sx={{ bgcolor: 'grey.900', color: 'common.white', '&:hover': { bgcolor: 'grey.800' } }}
    >
      Approve
    </Button>
  );
}
